// extracted by mini-css-extract-plugin
module.exports = {"mrecadpos":"g7IBF","LandingPageslider":"dYPjf"};